import React, { useState } from 'react';
import Config from 'react-native-config';

import { MuiButton, MuiBox, MuiGrid, MuiTypography } from 'theme/material-ui';
import { BookingMoreInfoButton } from '../../components/sharedComponents';
import * as bookingTypes from 'store/booking/types';
import BookingSymptomsDialog from 'screens/Booking/dialogs/BookingSymptomsDialog';
import TypographyInlineWrapper from 'components/UI/Typography/TypographyInLineWrapper';
import { FontSize, FontWeight, Spacing } from 'modules/styles/variables';
import { Color } from 'modules/styles/colors';
import { bookingVisitTypes } from 'modules/constants/booking';
import { AnalyticsEvent } from 'services/AnalyticsService';
import SelectSpecialty from '../../components/selectSpecialty';
import ServicesSection from '../servicesSection';
import LocationSection from '../locationSection';
import useNavigationAnalytics from 'hooks/useNavigationAnalytics';
import Box from 'components/UI/Layout/Box';

interface Props {
  handleMoreInfoOpen: Function;
  selectedSpecialty: bookingTypes.Specialty | null;
  handleSpecialtySelect: Function;
  specialties: bookingTypes.Specialty[];
  handleAddressSelect: Function;
  onNextPage: () => void;
  showNpvDesign: boolean;
  selectedAddress: bookingTypes.AddressItem[] | null;
}

const SpecialtiesSection = ({
  handleMoreInfoOpen,
  selectedSpecialty,
  handleSpecialtySelect,
  specialties,
  handleAddressSelect,
  onNextPage,
  showNpvDesign,
  selectedAddress
}: Props) => {
  const [isSymptomsDialogOpen, setSymptomsDialogOpen] = useState(false);
  const helpedUsedAnalitycs = useNavigationAnalytics(AnalyticsEvent.BookingHelpUsed);

  const handleSymptomsDialog = () => {
    helpedUsedAnalitycs({
      source_page: 'SpecialtyOrMyDoctorSelect(EmergencySymptom)'
    });
    setSymptomsDialogOpen(true);
  };

  return (
    <>
      <MuiGrid xs={12} container justify="space-between">
        <MuiGrid item xs>
          <MuiTypography gutterBottom variant="h6" fontWeight={FontWeight.normal}>
            Select a Specialty <span style={{ color: 'red' }}>*</span>
          </MuiTypography>
        </MuiGrid>
        <MuiGrid item>
          <BookingMoreInfoButton
            testID="booking-specialty-or-my-doctor-select-more-info-button"
            handleOpen={() => handleMoreInfoOpen()}
            size="medium"
          />
        </MuiGrid>
      </MuiGrid>
      <MuiGrid xs={12}>
        <MuiBox paddingTop={1}>
          <SelectSpecialty
            specialties={specialties}
            selectedSpecialty={selectedSpecialty}
            handleSpecialtySelect={handleSpecialtySelect}
          />
        </MuiBox>
      </MuiGrid>
      {showNpvDesign ? (
        <MuiGrid xs={12} justify="center">
          <LocationSection handleAddressSelect={handleAddressSelect} />
        </MuiGrid>
      ) : null}
      <BookingSymptomsDialog
        open={isSymptomsDialogOpen}
        handleClose={() => setSymptomsDialogOpen(false)}
      />
      <MuiBox paddingTop={4}>
        {selectedSpecialty?.nameLong === 'Behavioral Health Connect Care' ? (
          <MuiTypography data-testid="booking-visit-type-info-text" fontSize={FontSize.small}>
            {bookingVisitTypes.GET_VISIT_TYPES.BEHAVIORAL_HEALTH_INFO.message}
          </MuiTypography>
        ) : (
          <MuiTypography data-testid="booking-visit-type-info-text" fontSize={FontSize.small}>
            If you are experiencing any of these{' '}
            <TypographyInlineWrapper
              color={Color.link}
              fontSize={FontSize.small}
              onClick={() => handleSymptomsDialog()}
            >
              symptoms
            </TypographyInlineWrapper>{' '}
            please go to Emergency Room or call 911.{' '}
          </MuiTypography>
        )}
        <Box vOffset={Spacing.mediumLarge} />
      </MuiBox>
      <MuiGrid container xs={12} justify="center">
        <MuiButton
          variant="contained"
          disabled={showNpvDesign ? !(selectedSpecialty && selectedAddress) : !selectedSpecialty}
          color="primary"
          fullWidth
          onClick={onNextPage}
          data-testid="continue-to-Booking-Visit-Type-Select"
        >
          Next
        </MuiButton>
      </MuiGrid>
      {Config.COVID_SCREENING_FEATURE_FLAG === 'enabled' ? <ServicesSection /> : null}
    </>
  );
};

export default SpecialtiesSection;
